<script>
    export let weight;
    export let value;
</script>

<div class={`stats`}>
    <div class="stat">
        <img src={`/images/weight.png`} alt="glyph" />
        <span class="value">{weight.toFixed(1)}</span>
    </div>
    <div class="stat">
        <img src={`/images/value.png`} alt="glyph" />
        <span class="value">{value}</span>
    </div>
</div>

<style>
    .stats {
        display: flex;
    }
    .stats > * {
        margin-right: 8px;
    }
    .stat {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        min-width: 66px;
    }
    .value {
        margin-left: 4px;
        margin-top: 4px;
        min-width: 40px;
        text-align: end;

        font-family: LektonNumbers;
        font-weight: 600;
    }
</style>